const calcResidualValue = (lifetimeMiles) => {
  // 60% left after 36k miles / 12k miles per year over 3 years
  const ln0dot6 = -0.51082562376; // ln(0.6)
  const depreciationCoefficient = ln0dot6 / 36000;
  return Math.pow(Math.E, depreciationCoefficient * lifetimeMiles);
};

export default calcResidualValue;
